import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';

export default function FeaturedGrid() {
  const [activeIndex, setActiveIndex] = useState(0);
  const featured = articles.filter((a) => a.featured).slice(0, 5);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900">
            热门爆料 <span className="text-accent-500">🔥</span>
          </h2>
          <p className="text-foreground-600 text-sm mt-2">全网最火爆的吃瓜内容，大家都在看</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {featured.map((article, idx) => {
            const cat = categories.find((c) => c.slug === article.category);
            const isActive = activeIndex === idx;
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`group relative rounded-lg overflow-hidden cursor-pointer transition-all duration-500 ${
                  isActive ? 'md:col-span-2' : 'md:col-span-1'
                }`}
                onMouseEnter={() => setActiveIndex(idx)}
                style={{ minHeight: '380px' }}
              >
                <img
                  src={article.imageUrlLarge}
                  alt={article.title}
                  title={article.title}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-black/10"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 mb-3">
                    {cat?.name || article.category}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-white mb-2 group-hover:text-accent-200 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  {isActive && (
                    <p className="text-white/70 text-sm line-clamp-2 animate-fadeIn">{article.excerpt}</p>
                  )}
                  <div className="flex items-center gap-3 mt-3 text-white/50 text-xs">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views} 阅读
                    </span>
                    <span>{article.publishedAt}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}